import React from 'react';
import { ChevronDown } from 'lucide-react';
export function HeroSection() {
  const scrollToPricing = () => {
    document.getElementById('checkout')?.scrollIntoView({
      behavior: 'smooth'
    });
  };
  return <section className="relative min-h-screen w-full flex flex-col items-center justify-center px-4 py-20 overflow-hidden bg-[#050505] text-[#f5f0e8]" data-id="element-202">
      {/* Simple radial gradient - no blur, pure CSS */}
      <div className="absolute top-1/2 left-1/2 -translate-x-1/2 -translate-y-1/2 w-[600px] h-[600px] rounded-full pointer-events-none" style={{
      background: 'radial-gradient(circle, rgba(180,140,30,0.08) 0%, transparent 70%)'
    }} data-id="element-203"></div>

      <div className="relative z-10 max-w-4xl mx-auto text-center flex flex-col items-center" data-id="element-204">
        <div className="animate-[fadeInUp_0.6s_ease-out_both]" data-id="element-205">
          <span className="inline-block py-1 px-3 rounded-full border border-yellow-900/30 bg-yellow-900/10 text-yellow-500 text-xs tracking-widest uppercase mb-6" data-id="element-206">
            Identidad rentable + Protocolo Plano
          </span>

          <h1 className="font-serif text-5xl md:text-7xl lg:text-8xl font-bold tracking-tight leading-[1.1] mb-6" data-id="element-207">
            TRADING EN{' '}
            <span className="text-transparent bg-clip-text bg-gradient-to-r from-[#b8942e] via-[#d4af37] to-[#e8c84a]" data-id="element-208">
              PAZ
            </span>
          </h1>

          <p className="text-xl md:text-2xl text-[#8a8578] max-w-2xl mx-auto font-light leading-relaxed mb-8" data-id="element-209">
            El Protocolo de Blindaje Emocional que detiene el autosabotaje y la
            quema de cuentas por impulsividad.
          </p>

          <button onClick={scrollToPricing} className="mb-12 px-8 py-4 bg-gradient-to-r from-[#b8942e] via-[#d4af37] to-[#e8c84a] text-black font-bold text-lg tracking-wide rounded shadow-lg hover:shadow-yellow-500/20 transition-all hover:scale-105 active:scale-95 animate-[glow_2s_ease-in-out_infinite]" data-id="element-210">
            QUIERO OPERAR EN PAZ
          </button>
        </div>

        <div className="relative w-full max-w-3xl mx-auto mb-16 animate-[fadeIn_0.8s_ease-out_0.2s_both]" data-id="element-211">
          <img src="https://cdn.magicpatterns.com/uploads/uBsbLjcCL3Zh7KUEvQoEGP/Imagen_5_del_producto.png" alt="Trading en Paz Product Mockup" className="relative z-10 w-full h-auto" fetchPriority="high" width={768} height={512} data-id="element-212" />
        </div>

        <div className="absolute bottom-2 md:bottom-4 left-1/2 -translate-x-1/2 flex flex-col items-center gap-2 text-[#8a8578] animate-[fadeIn_1s_ease-out_1s_both]" data-id="element-213">
          <span className="text-xs uppercase tracking-widest opacity-60" data-id="element-214">
            Descubre la verdad
          </span>
          <ChevronDown className="w-6 h-6 animate-bounce text-[#d4af37]" data-id="element-215" />
        </div>
      </div>
    </section>;
}